import React from 'react';
import classNames from 'classnames';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import InfiniteScroll from 'react-infinite-scroller';
import { isDirty } from 'redux-form';

import { onSelectItem, getItemsRequest } from 'actions/businessLibrary/item';

import styles from './List.css';

const LockableHeader = props => {
  const { isLocked, children, ...rest } = props;

  if (isLocked) {
    const cellClass = classNames(props.className, styles.lockedCell);
    return (
      <th {...rest} className={cellClass}>
        <i className="glyphicon glyphicon-lock" />
        &nbsp;
        {children}
      </th>
    );
  }

  return <th {...rest}>{children}</th>;
};

class List extends React.Component {
  render() {
    const { items, itemMeta } = this.props;

    return (
      <div className={styles.wrapper}>
        <div className="full-height">
          <div className={`${styles.leftcol} no-padding`} id="mk-col-left">
            <table className={styles['table-header']}>
              <thead>
                <tr>
                  <th className={styles.headerName}>Name</th>
                  <LockableHeader className={styles.headerCategory}>
                    Category
                  </LockableHeader>
                  <th className={styles.headerPrice}>Pricing</th>
                  <LockableHeader className={styles.headerInStock}>
                    Outlet Availability
                  </LockableHeader>
                </tr>
              </thead>
            </table>
            {itemMeta !== undefined && itemMeta.total_items > 0 && (
              <div
                className={`${
                  styles['table-content-wrapper']
                } item-library-table-content-wrapper`}
              >
                <InfiniteScroll
                  pageStart={1}
                  hasMore={this.hasMore()}
                  loadMore={this.onReachBottom}
                  useWindow={false}
                  threshold={10}
                  initialLoad={false}
                >
                  <table className={styles['table-content']}>
                    <tbody>
                      {itemMeta.total_items > 0 &&
                        items.map(item => {
                          return (
                            <tr
                              key={item.id}
                              onClick={() => this._onClickRow(item)}
                            >
                              <td className={styles.headerName}>{item.name}</td>
                              <td className={styles.headerCategory}>
                                {item.category.name}
                              </td>
                              <td className={styles.headerPrice}>
                                {this._priceFormatter(item)}
                              </td>
                              <td className={styles.headerInStock}>
                                {this._outletAvailability(item)}
                              </td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                </InfiniteScroll>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  _onClickRow = item => {
    const { onSelectItem } = this.props;
    onSelectItem(item);
  };

  hasMore = () => {
    const {
      itemMeta: { total_pages, current_page },
    } = this.props;
    return current_page < total_pages;
  };

  onReachBottom = () => {
    const {
      getItemsRequest,
      itemMeta: { current_page, total_pages },
      items,
      filterState,
    } = this.props;
    if (current_page < total_pages) {
      getItemsRequest({ page: current_page + 1, filterState }, items);
    }
  };

  _priceFormatter = item => {
    const itemVariants = item.item_variants;

    if (item.is_sales_type_price) {
      return 'Sales Type';
    }

    if (itemVariants.length > 1) {
      return `${itemVariants.length} Prices`;
    }

    if (itemVariants.length < 2 && itemVariants.length !== 0) {
      const { price } = itemVariants[0];
      if (itemVariants[0].is_variable_price || price === null) {
        return 'Variable';
      }
      return this._currencyFormatter(price);
    }
  };

  _outletAvailability = item => {
    const { outlets } = this.props;
    if (outlets.length === item.item_outlets.length) {
      return 'All Outlets';
    }
    return `${item.item_outlets.length} out of ${outlets.length}`;
  };

  _currencyFormatter = data => {
    if (isNaN(data)) return 'Rp. 0';
    const currency = 'Rp. ';
    let result = '';
    data = data || 0;
    if (data < 0) {
      data *= -1;
      result = `(${currency}${data.toString()})`;
    } else {
      result = currency + data.toString();
    }
    return result.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1.');
  };

  _inStockFormatter = item => {
    const itemVariants = item.item_variants;
    let total = 0;
    let count = 0;

    for (let i = 0; i < itemVariants.length; i++) {
      const itemVariant = itemVariants[i];

      if (itemVariant.track_stock) {
        count += 1;
        if (itemVariant.in_stock) {
          total += parseInt(itemVariant.in_stock);
        }
      }
    }

    if (count > 0) {
      return total;
    }
    return total === 0 ? '' : total;
  };
}

function mapStateToProps(state) {
  const {
    items,
    itemMeta,
    filterState,
    outlets,
  } = state.businessLibrary.itemHub;
  return {
    items,
    itemMeta,
    isDirtyItem: isDirty('itemHub')(state),
    filterState,
    outlets,
  };
}

const mapDispatchToProps = {
  onSelectItem,
  getItemsRequest,
};

List.propTypes = {
  dispatch: PropTypes.func,
  items: PropTypes.array,
  itemDetail: PropTypes.object,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(List);
